import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-taxi-wheelchair-modal',
  templateUrl: './taxi-wheelchair-modal.component.html',
  styleUrls: ['./taxi-wheelchair-modal.component.scss'],
  standalone: false
})
export class TaxiWheelchairModalComponent implements OnInit {
  specialRequirementsText = '';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}
}
LightningModalTypes.TaxiWheelchairModalComponent.component = TaxiWheelchairModalComponent;
